import {Component, EventEmitter, Input, Output} from '@angular/core';
import {fadeIn} from "../../animations/router-animation";

@Component({
  selector: 'prev-next-btn',
  templateUrl: './prev-next-btn.component.html',
  styleUrl: './prev-next-btn.component.scss',
  animations: [fadeIn]
})
export class PrevNextBtnComponent {

  @Input() prevDisabled = false;

  @Input() nextDisabled = false;

  @Input() confirmFirst = false;

  @Input() nextTitle = 'Next';

  @Input() prevTitle = 'Back';

  @Input() loading = false;

  @Input() confirmText = 'Are you sure you want to perform this action?';

  @Input() loadingMessage = 'Saving Data Please Wait...';

  @Output()
  goPrev = new EventEmitter<any>();

  @Output()
  goNext = new EventEmitter<any>();

  @Input() showConfirm = false;

}
